module.exports = __webpack_public_path__ + "assets/45e28366d99fd9961b400aff0c1671c4.png";